import type { ComponentPropsWithoutRef, MouseEvent } from "react";
import { useState } from "react";
import { downloadAuthenticatedUrl } from "../../helpers/authenticatedDownload";
import notify from "../../helpers/notify";

type Props = Omit<ComponentPropsWithoutRef<"a">, "href"> & {
  downloadName?: string;
  url: string;
};

export default function AuthenticatedDownloadLink({ children, downloadName, onClick, url, ...props }: Props) {
  const [pending, setPending] = useState(false);

  const download = async (event: MouseEvent<HTMLAnchorElement>) => {
    onClick?.(event);
    if (event.defaultPrevented) return;
    event.preventDefault();
    if (pending) return;
    setPending(true);
    try {
      await downloadAuthenticatedUrl(url, downloadName);
    } catch {
      notify("Unable to download the file. Please try again.");
    } finally {
      setPending(false);
    }
  };

  return (
    <a
      {...props}
      aria-busy={pending || undefined}
      href="#authenticated-download"
      onAuxClick={(event) => event.preventDefault()}
      onClick={(event) => void download(event)}
    >
      {children}
    </a>
  );
}
